import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  input,
  Input,
  TemplateRef,
} from '@angular/core';
import { CartItem } from '@pedix-workspace/utils';
import { endOrderToOrderItemsByCategories, OrderItemsByCategories } from '@pedix-workspace/orders';
import { NgTemplateOutlet } from '@angular/common';
import clsx from 'clsx';

@Component({
    selector: 'pxw-cart-items-list',
    templateUrl: './cart-items-list.component.html',
    styleUrls: ['./cart-items-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet]
})
export class CartItemsListComponent {
  @ContentChild('itemTemplate') itemTemplate: TemplateRef<{ $implicit: CartItem; index: number }>;

  readonly columns = input<number>(1);

  protected orderItems: OrderItemsByCategories;

  @HostBinding('class')
  get classNames() {
    return clsx({
      'cart-items-list--columns-1': this.columns() === 1,
      'cart-items-list--columns-2': this.columns() > 1,
    });
  }

  @Input() set cartItems(cartItems: CartItem[]) {
    this.orderItems = endOrderToOrderItemsByCategories(cartItems);
  }
  @Input() undefinedGroupName = 'string';
}
